import { useNavigate, useSearchParams } from '@remix-run/react'
import { ChevronLeftIcon } from 'lucide-react'

import { CartDrawerTrigger } from '~/components/cart'
import { makeShopOwnPath } from '~/helpers/routes'
import { useOptionalSeller } from '~/hooks/data/use-seller'
import { useShop } from '~/hooks/data/use-shop'
import { IconButton } from '~/ui'
import { cn } from '~/utils/classnames'

interface InnerPageTopNavProps {
  className?: string
  children?: React.ReactNode
}

export const InnerPageTopNav = ({
  className,
  children,
}: InnerPageTopNavProps) => {
  const shop = useShop()
  const seller = useOptionalSeller()
  const navigate = useNavigate()
  const [search] = useSearchParams()

  const handleGoBack = () => {
    const backTo = search.get('backTo')
    if (backTo) {
      navigate(backTo)
      return
    }

    navigate(makeShopOwnPath(shop, '/'))
  }
  return (
    <nav
      className={cn(
        'bg-background sticky top-0 z-30 grid h-(--inner-page-top-nav-height) grid-cols-[1fr_auto_1fr] items-center justify-between px-2 @md:px-4 @lg:px-6',
        seller && 'rounded-t-2xl',
        className
      )}
    >
      <IconButton variant="ghost" aria-label="Go back" onClick={handleGoBack}>
        <ChevronLeftIcon />
      </IconButton>
      {children ?? <div />}
      <div className="justify-self-end">{!seller && <CartDrawerTrigger />}</div>
    </nav>
  )
}
